// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card___JMfh","productLink":"styles_productLink__y_wCr","productName":"styles_productName__np2Ef","actionBtn":"styles_actionBtn__VeZiY"};